export const formatDateToNumeric = (date) => {
    const options = {month: '2-digit', day: '2-digit', year: 'numeric'};
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

export const formatDateToString = (date) => {
    const options = {month: 'long', day: 'numeric', year: 'numeric'};
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };
